export default __webpack_public_path__ + "static/media/Asset 5.2d5bdcb5.png";